import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'credit-box',
    templateUrl: './credit-box.component.html',
    styleUrls: ['./credit-box.component.scss'],
    standalone: false
})
export class CreditBoxComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
